import React from 'react';
import { CardListFieldsFragment } from "@src/generated/graphql";
import { highlightBracketedText, highlightUnderscoreText } from 'src/utils/utils';

type EnterpriseCardListProps = {
  content: CardListFieldsFragment;
};

const EnterpriseCardList = ({ content }:EnterpriseCardListProps) => {
  const { title, cardsCollection, description } = content;
  const items = cardsCollection?.items ?? [];

  if (!content) return null;

  return (
    <section className="enterprise-card-list">
      <div className="enterprise-card-list__header">
        <h2
          className="enterprise-card-list__title"
          dangerouslySetInnerHTML={{
            __html: highlightBracketedText(title ?? "", "bold"),
          }}
        />
        <p className="enterprise-card-list__description">{description}</p>
      </div>

      <div className="enterprise-card-list__items">
        {items.map((card, index) => (
          <div key={index} className="enterprise-card-list__item">
            <div className="enterprise-card-list__item-title">
              {card?.cardTitle}
            </div>
            <div className="enterprise-card-list__item-content">
              <div 
                className="enterprise-card-list__item-description"
                dangerouslySetInnerHTML={{ 
                  __html: highlightUnderscoreText(
                    card?.cardDescription?.json?.content[0]?.content[0]?.value ?? ""
                  )
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EnterpriseCardList;